import { render, staticRenderFns } from "./SelectSpecificItems.vue?vue&type=template&id=d638fc7c&scoped=true&"
import script from "./SelectSpecificItems.vue?vue&type=script&lang=ts&"
export * from "./SelectSpecificItems.vue?vue&type=script&lang=ts&"
import style0 from "./SelectSpecificItems.vue?vue&type=style&index=0&id=d638fc7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d638fc7c",
  null
  
)

export default component.exports